import { ContextStore } from '../../../react-core/Flux/Variables';
import { RoutesHelper } from '../../../react-core/Utils/RoutesHelper';
import { AjaxWrapper } from '../../../react-core/Async/AjaxWrapper';
import { Promise } from '../../../react-core/Async/Promise';
import { IApiError } from '../../../react-core/Core/ApiError';
import { ApplyModel } from '../../Models/Models/Processes/Apply/ApplyModel';
import { ApplyErrors } from '../../Validation/Errors/Apply/ApplyErrors';
import { QuoteModel } from '../../Models/Models/Processes/Quote/QuoteModel';

declare var IS_RUNNING_IN_APP_POOL;

export class QuoteToApplyInstructionClient {
  private _culture: string;

  public constructor() {
    var contextStoreState = ContextStore.getContext();
    this._culture = contextStoreState.culture;
  }

  public put(quoteModel: QuoteModel): Promise<ApplyModel, IApiError<ApplyErrors>[]> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/Apply/QuoteToApplyInstruction/Put';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = { quoteModel: quoteModel }

    return AjaxWrapper.post<ApplyModel, IApiError<ApplyErrors>[]>(url, data);
  }
}

